import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthAlertState {
  isVisible: boolean;
  message: string;
  shouldRetry: boolean;
}

const initialState: AuthAlertState = {
  isVisible: false,
  message: 'Il y a un problème réseau et vous devez vous réauthentifier.',
  shouldRetry: true,
};

const authAlertSlice = createSlice({
  name: 'authAlert',
  initialState,
  reducers: {
    showAuthAlert: (state, action: PayloadAction<{ message?: string; shouldRetry?: boolean }>) => {
      state.isVisible = true;
      state.message = action.payload.message || initialState.message;
      state.shouldRetry = action.payload.shouldRetry !== false;
    },
    hideAuthAlert: (state) => {
      state.isVisible = false;
    },
    clearAuthAlert: (state) => {
      state.isVisible = false;
      state.message = initialState.message;
      state.shouldRetry = true;
    },
  },
});

export const { showAuthAlert, hideAuthAlert, clearAuthAlert } = authAlertSlice.actions;
export default authAlertSlice.reducer;
